// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-screen .home {
  min-width: 150px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-perspective: 1000px;
          perspective: 1000px;
}
.home-screen .home .logo {
  /* BLUE <-> RED
    background: linear-gradient(
      315deg,
      rgb(56 36 145) 37.5%,
      rgb(211 18 17) 62.5%
    ); 
  */
  -webkit-transform: rotate3d(0, 1, 0, 25deg);
          transform: rotate3d(0, 1, 0, 25deg);
  -webkit-box-shadow: -5px 0px 20px 0px rgba(0, 0, 0, 0.2);
          box-shadow: -5px 0px 20px 0px rgba(0, 0, 0, 0.2);
  background: linear-gradient(315deg, rgb(36, 145, 91) 37.5%, rgb(211, 18, 17) 62.5%);
  background-size: 400% 400%;
  background-position: 50%;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  min-width: 300px;
  margin-bottom: 0;
}
.home-screen .home .logo .illustration {
  height: 100%;
  width: 100%;
  -webkit-filter: drop-shadow(-10px 4px 6px rgba(0, 0, 0, 0.25));
          filter: drop-shadow(-10px 4px 6px rgba(0, 0, 0, 0.25));
}
.home-screen .home .logo img {
  padding: 25px;
  opacity: 0.95;
  -webkit-filter: drop-shadow(0px 0px 0px rgb(0, 0, 0));
          filter: drop-shadow(0px 0px 0px rgb(0, 0, 0));
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}
.home-screen .home .logo.red {
  background-position: 0.1%;
}
.home-screen .home .logo.red img {
  -webkit-transform: translate(2%, 0);
          transform: translate(2%, 0);
  -webkit-filter: drop-shadow(-5px 0px 3px rgba(0, 0, 0, 0.4));
          filter: drop-shadow(-5px 0px 3px rgba(0, 0, 0, 0.4));
}
.home-screen .home .logo.green, .home-screen .home .logo.blue {
  background-position: 99.9%;
}
.home-screen .home .logo.green img, .home-screen .home .logo.blue img {
  -webkit-transform: translate(2%, 0);
          transform: translate(2%, 0);
  -webkit-filter: drop-shadow(-5px 0px 3px rgba(0, 0, 0, 0.4));
          filter: drop-shadow(-5px 0px 3px rgba(0, 0, 0, 0.4));
}
.home-screen .home .logo.selected img {
  -webkit-transform: translate(3.5%, 0);
          transform: translate(3.5%, 0);
  -webkit-filter: drop-shadow(-10px 0px 7px rgba(0, 0, 0, 0.3));
          filter: drop-shadow(-10px 0px 7px rgba(0, 0, 0, 0.3));
}
.home-screen .home .actions {
  padding: 20px 0 0;
  width: auto;
  width: initial;
}
.home-screen .home .actions small {
  font-size: 0.65em;
}
.home-screen .home .actions button {
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  min-width: 75px;
}
.home-screen .home .action-panel {
  margin: 50px;
}
@media screen and (max-width: 720px) {
  .home-screen .home {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    min-width: 100%;
  }
  .home-screen .home .logo {
    -webkit-transform: none;
            transform: none;
    min-width: 250px;
  }
  .home-screen .home .logo .illustration {
    height: 250px;
  }
  .home-screen .home .action-panel {
    margin: 35px;
  }
}
.home-screen footer {
  margin-top: 25px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/screens/home.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,2BAAA;UAAA,mBAAA;AAAJ;AAEI;EACE;;;;;;GAAA;EAcA,2CAAA;UAAA,mCAAA;EACA,wDAAA;UAAA,gDAAA;EAEA,mFAAA;EAKA,0BAAA;EACA,wBAAA;EACA,4BAAA;EAAA,oBAAA;EACA,gBAAA;EACA,gBAAA;AAZN;AANM;EACE,YAAA;EACA,WAAA;EACA,8DAAA;UAAA,sDAAA;AAQR;AASM;EACE,aAAA;EACA,aAAA;EACA,qDAAA;UAAA,6CAAA;EACA,4BAAA;EAAA,oBAAA;AAPR;AAUM;EACE,yBAAA;AARR;AAUQ;EACE,mCAAA;UAAA,2BAAA;EACA,4DAAA;UAAA,oDAAA;AARV;AAYM;EAEE,0BAAA;AAXR;AAaQ;EACE,mCAAA;UAAA,2BAAA;EACA,4DAAA;UAAA,oDAAA;AAXV;AAeM;EACE,qCAAA;UAAA,6BAAA;EACA,6DAAA;UAAA,qDAAA;AAbR;AAiBI;EACE,iBAAA;EACA,WAAA;EAAA,cAAA;AAfN;AAiBM;EACE,iBAAA;AAfR;AAkBM;EACE,mBAAA;MAAA,WAAA;UAAA,OAAA;EACA,eAAA;AAhBR;AAoBI;EACE,YAAA;AAlBN;AAsBE;EACE;IACE,4BAAA;IAAA,6BAAA;QAAA,0BAAA;YAAA,sBAAA;IACA,eAAA;EApBJ;EAsBI;IACE,uBAAA;YAAA,eAAA;IACA,gBAAA;EApBN;EAsBM;IACE,aAAA;EApBR;EAwBI;IACE,YAAA;EAtBN;AACF;AA0BE;EACE,gBAAA;EACA,kBAAA;AAxBJ","sourcesContent":[".home-screen {\n  .home {\n    min-width: 150px;\n    display: flex;\n    perspective: 1000px;\n\n    .logo {\n      /* BLUE <-> RED\n        background: linear-gradient(\n          315deg,\n          rgb(56 36 145) 37.5%,\n          rgb(211 18 17) 62.5%\n        ); \n      */\n\n      .illustration {\n        height: 100%;\n        width: 100%;\n        filter: drop-shadow(-10px 4px 6px rgba(0, 0, 0, 0.25));\n      }\n\n      transform: rotate3d(0, 1, 0, 25deg);\n      box-shadow: -5px 0px 20px 0px rgba(0, 0, 0, 0.2);\n\n      background: linear-gradient(\n        315deg,\n        rgb(36 145 91) 37.5%,\n        rgb(211 18 17) 62.5%\n      );\n      background-size: 400% 400%;\n      background-position: 50%;\n      transition: all 0.5s;\n      min-width: 300px;\n      margin-bottom: 0;\n\n      img {\n        padding: 25px;\n        opacity: 0.95;\n        filter: drop-shadow(0px 0px 0px rgba(0, 0, 0, 1));\n        transition: all 0.5s;\n      }\n\n      &.red {\n        background-position: 0.1%;\n\n        img {\n          transform: translate(2%, 0);\n          filter: drop-shadow(-5px 0px 3px rgba(0, 0, 0, 0.4));\n        }\n      }\n\n      &.green,\n      &.blue {\n        background-position: 99.9%;\n\n        img {\n          transform: translate(2%, 0);\n          filter: drop-shadow(-5px 0px 3px rgba(0, 0, 0, 0.4));\n        }\n      }\n\n      &.selected img {\n        transform: translate(3.5%, 0);\n        filter: drop-shadow(-10px 0px 7px rgba(0, 0, 0, 0.3));\n      }\n    }\n\n    .actions {\n      padding: 20px 0 0;\n      width: initial;\n\n      small {\n        font-size: 0.65em;\n      }\n\n      button {\n        flex: 1;\n        min-width: 75px;\n      }\n    }\n\n    .action-panel {\n      margin: 50px;\n    }\n  }\n\n  @media screen and (max-width: 720px) {\n    .home {\n      flex-direction: column;\n      min-width: 100%;\n\n      .logo {\n        transform: none;\n        min-width: 250px;\n\n        .illustration {\n          height: 250px;\n        }\n      }\n\n      .action-panel {\n        margin: 35px;\n      }\n    }\n  }\n\n  footer {\n    margin-top: 25px;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
